import type { ReactNode } from 'react';

export interface EmptyStateProps {
  title: string;
  children?: ReactNode;
  action?: ReactNode;
}

export function EmptyState({ title, children, action }: EmptyStateProps) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 'var(--sp-3)',
        textAlign: 'center',
        padding: 'var(--sp-10) var(--sp-5)',
        color: 'var(--text-secondary)',
      }}
    >
      <div style={{ fontFamily: 'var(--font-display)', fontSize: 'var(--fs-h3)', color: 'var(--text)' }}>
        {title}
      </div>
      {children && <div style={{ fontSize: 'var(--fs-body-md)', maxWidth: 320 }}>{children}</div>}
      {action}
    </div>
  );
}
